import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { TableContext } from "../utils/context/table-context";
import { CustomCard } from "../components/cards/CustomCard";
import { TabContext } from "../utils/context/tab-context";
import { Stack } from "@mui/material";
import { CustomTable } from "../components/data-table/CustomTable";
import { CardHeader } from "../components/cards/CardHeader";

export const CreditCards = () => {
  const [fetchData, setFetchData] = useState<boolean>(true);
  const isUserImageFetching: boolean = useOutletContext();

  return (
    <TableContext.Provider value={{ fetchData, setFetchData, isUserImageFetching }}>
      <CustomCard>
        <TabContext.Provider value={{ selectedTab: "creditCards" }}>
          <Stack height={"100%"}>
            <CardHeader btnLabel={"Add New Credit Card"} />
            <CustomTable />
          </Stack>
        </TabContext.Provider>
      </CustomCard>
    </TableContext.Provider>
  );
};
